import { render } from "./CustomerStep.vue?vue&type=template&id=618a9356&ts=true"
import script from "./CustomerStep.vue?vue&type=script&lang=ts"
export * from "./CustomerStep.vue?vue&type=script&lang=ts"

import "./CustomerStep.vue?vue&type=style&index=0&id=618a9356&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__